import React from "react";
import AppHeader from "./AppHeader/AppHeader";
import AppFooter from "./AppFooter/AppFooter";
import AppContainer from "./AppContainer/AppContainer";
import CssBaseline from "@mui/material/CssBaseline";
import { Content, Root } from "./AppLayout.styles";
import AppSnackBar from "../AppSnackBar/AppSnackBar";

const AppLayout: React.FC = () => {
  return (
    <Root>
      <CssBaseline />
      <AppHeader></AppHeader>
      <Content>
        <AppContainer></AppContainer>
      </Content>
      <AppFooter></AppFooter>
      <AppSnackBar></AppSnackBar>
    </Root>
  );
};

export default AppLayout;
